import { render } from "./Salespitch.vue?vue&type=template&id=edca2cd8&scoped=true"
import script from "./Salespitch.vue?vue&type=script&lang=js"
export * from "./Salespitch.vue?vue&type=script&lang=js"

import "./Salespitch.vue?vue&type=style&index=0&id=edca2cd8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edca2cd8"]])

export default __exports__